import classnames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

import Icon from 'dpl/common/components/Icon';
import { sendRudderstackEvent } from 'dpl/util/analytics';
import { ANALYTICS_EVENTS } from 'dpl/constants/analytics';

export default function FilterPill({
  label,
  prefixIconName,
  displayDropdownArrow,
  className,
  onClick,
  isSelected,
  analytics,
  isOpen
}) {
  function handleClick() {
    // only call analytics events when gender filter is first applied, not when it's also de-selected
    const shouldCallAnalytics =
      label === 'Male' || label === 'Female' ? !isSelected : true;
    if (shouldCallAnalytics) {
      sendRudderstackEvent(ANALYTICS_EVENTS.BUTTON_CLICKED, analytics);
    }
    onClick();
  }

  return (
    <button className="dib" type="button" onClick={handleClick}>
      <span
        className={classnames(
          'flex nowrap items-center br1 pv2 pl3 ba secondary',
          {
            pr3: !displayDropdownArrow,
            pr2: displayDropdownArrow,
            'b--default': !isSelected,
            'b--stone-700 bg-subtle-light-gray stone-700': isSelected
          },
          className
        )}
      >
        {Boolean(prefixIconName) && (
          <Icon
            className={classnames(
              'mr2',
              classnames({
                tertiary: !isSelected,
                'stone-700': isSelected
              })
            )}
            name={prefixIconName}
            width="24px"
            height="24px"
          />
        )}
        <span className="font-14 fw-medium">{label}</span>
        {displayDropdownArrow && (
          <Icon
            name={isOpen ? 'fetch-chevron-up' : 'fetch-chevron-down'}
            width="20px"
            height="20px"
          />
        )}
      </span>
    </button>
  );
}

FilterPill.propTypes = {
  label: PropTypes.string.isRequired,
  prefixIconName: PropTypes.string.isRequired,
  displayDropdownArrow: PropTypes.bool,
  className: PropTypes.string,
  onClick: PropTypes.func,
  isSelected: PropTypes.bool.isRequired,
  analytics: PropTypes.shape({
    button_cta: PropTypes.string.isRequired,
    view: PropTypes.string.isRequired,
    view_feature: PropTypes.string.isRequired,
    view_feature_location: PropTypes.string.isRequired
  }).isRequired,
  isOpen: PropTypes.bool
};

FilterPill.defaultProps = {
  className: null,
  displayDropdownArrow: false,
  onClick: null,
  isOpen: false
};
